import { render, staticRenderFns } from "./MealTypes.vue?vue&type=template&id=9462afc8&"
import script from "./MealTypes.vue?vue&type=script&lang=js&"
export * from "./MealTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports